/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Route, Switch, Redirect } from "react-router-dom";

// core components
import DemoNavbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { Alert } from "components/Varios/Alert.js";
import DatosGenerales from 'components/DatosGenerales';

import { history } from '../helpers/history';
import { Role } from '../helpers/role';
import { authenticationService } from '../services/authentication.service';
import { PrivateRoute } from '../components/Varios/PrivateRoute';

import routes from "routes.js";

//Barras de navegacion
import MetisMenu from 'react-metismenu';
import MultilevelSidebar from "react-multilevel-sidebar";
import "react-multilevel-sidebar/src/Sidebar.css";
//Componentes para inicio sin login
import Dashboards_Inicio from "components/NoLogin/Dashboard_Inicio";
import Banner_Inicio from "components/NoLogin/Banner_Inicio";

//Componente para dashboard con login
import Dashboard_Admin from "components/Admin/Inicio-Admin/Dashboard_Admin";
import Sidebar_Principal from "components/Sidebar/Sidebar_Principal";

//Rutas web

import USUARIOS_ROUTES from "../components/UsuarioGeneral/RutasUsuario";
// Para efectos
import { Transition } from 'react-transition-group'
import ModalActualizarDatosPers from "components/Varios/ModalActualizarDatosPers";
import { detectResize } from "./functionsLayout";

import ModalTiempoSesion from "components/Varios/ModalTiempoSesion";

import { ROUTE_HOJA_MARCACIONES } from "Context/SideBarContext";
import HojaMarcaciones from "../components/UsuarioGeneral/Hoja Marcaciones/HojaMarcaciones";
var ps;

class Dashboard extends React.Component {
    state = {
        currentUser: null,
        backgroundColor: "blue",
        openSideBar: true,
        showModalCambios: true,
        showModalSession: false
    };
    mainPanel = React.createRef();
    callBackStateResize = () => {
        this.setState({ openSideBar: true })
    }

    isSessionActive = () => {
        const tiempoExpiraSesion = new Date(authenticationService.currentUserValue.fechaHoraSesionActiva);
        const fechaActual = new Date(authenticationService.currentUserValue.fechaHoraSesionComparar);
        var fechaActualizado = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), fechaActual.getHours(), fechaActual.getMinutes(), fechaActual.getSeconds() + 23)

        if (document.visibilityState === 'hidden') {
            // Browser window is minimized or tab is switched
            fechaActualizado = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), fechaActual.getHours(), fechaActual.getMinutes(), fechaActual.getSeconds() + 27)
        }

        authenticationService.UpdateSessionCompareTime(fechaActualizado);

        //console.log(tiempoExpiraSesion,fechaActualizado, new Date());
        if (tiempoExpiraSesion.getTime() > fechaActualizado.getTime()) {
            ;

        }
        else {

            this.setState({ showModalSession: true });
        }
        this.runFunction();
    };

    runFunction = () => {
        // Use setTimeout instead of setInterval
        // This ensures that the function is called after a delay
        // even if the browser window is minimized
        this.timeout = setTimeout(this.isSessionActive, 20000); // Example: 1 second delay
    }

    handleVisibilityChange = () => {
        // No action needed when visibility changes
        // The timeout will continue running regardless of visibility state
    }

    componentDidMount() {
        if (navigator.platform.indexOf("Win") > -1) {
            // ps = new PerfectScrollbar(this.mainPanel.current);
            // document.body.classList.toggle("perfect-scrollbar-on");
        }

        authenticationService.currentUser.subscribe(x => this.setState({
            currentUser: x
        }));

        window.addEventListener("resize", () => detectResize(this.callBackStateResize));
        document.addEventListener("visibilitychange", this.handleVisibilityChange);


        this.runFunction()


    }
    componentWillUnmount() {
        if (navigator.platform.indexOf("Win") > -1) {
            // ps.destroy();
            // document.body.classList.toggle("perfect-scrollbar-on");
        }

        window.removeEventListener('resize', this.callBackStateResize);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
        clearTimeout(this.timeout);


    }
    componentDidUpdate(e) {
        // if (e.history && e.history.action === "PUSH") {
        //     document.documentElement.scrollTop = 0;
        //     document.scrollingElement.scrollTop = 0;
        //     this.mainPanel.current.scrollTop = 0;
        // }
    }
    handleColorClick = (color) => {
        this.setState({ backgroundColor: color });
    };
    logout() {
        authenticationService.logout();
    }

    render() {
        const { currentUser, isAdmin } = this.state;
        return this.renderPage(this.props, this.backgroundColor, currentUser, isAdmin);
    }



    handleSidebarToggle = isOpen => {
        this.setState({ openSideBar: isOpen });
    };


    renderPage(props, backgroundColor, currentUser, isAdmin) {
        return (
            <div>
                <DemoNavbar {...this.props} />

                {/* {currentUser === null || currentUser.idpersona ===0 &&
                        <React.Fragment>
                            <Banner_Inicio/>
                            <Dashboards_Inicio/>
                        </React.Fragment>
                       
                    } */}
                <div ref={this.mainPanel} />
                {currentUser !== null && currentUser.idpersona !== 0 &&
                    <div className="parent_supremo" /*style={{ overflowY: "scroll", height: "100vh", overflow: "visible", overflowAnchor: "none" }}*/>

                        <div className="parent_contenido_pantalla">
                            {/* {currentUser !== null && currentUser.idpersona !== 0 && <Sidebar_Principal/>} */}
                            <div className="btn_mostrar_barra" onClick={() => this.setState({ openSideBar: !this.state.openSideBar })}> <i className="fas fa-solid fa-bars" ></i> </div>

                            <Transition
                                in={this.state.openSideBar && currentUser !== null && currentUser.idpersona !== 0}
                                timeout={400}
                                unmountOnExit
                                mountOnEnter

                            >
                                {state => (

                                    <Sidebar_Principal onClickOverlay={() => this.setState({ openSideBar: false })} />
                                )}
                            </Transition>
                            <div className="main-panel" display="none" id="main-panel" ref={this.mainPanel}>
                                {/* {currentUser !== null && currentUser.idpersona !== 0 &&<Dashboard_Admin/>} */}

                                <Alert />




                                <Switch>
                                    {USUARIOS_ROUTES.map((prop, key) => {
                                        if (prop.path === '/notificacion_embarazo') {
                                            // Verificar si el usuario es mujer
                                            if (currentUser.genero === 'F') {
                                                return (
                                                    <Route
                                                        path={prop.layout + prop.path}
                                                        component={prop.component}
                                                        key={key}
                                                    />
                                                );
                                            }
                                        } else {
                                            return (
                                                <Route
                                                    path={prop.layout + prop.path}
                                                    component={prop.component}
                                                    key={key}
                                                />
                                            );
                                        }
                                    })}
                                    {/*{USUARIOS_ROUTES.map((prop, key) => {
                                        return (
                                            <Route
                                                path={prop.layout + prop.path}
                                                component={prop.component}
                                                key={key}
                                            />

                                        );
                                    })}*/}
                                   


                                </Switch>
                                {/* <Switch>
                                    {routes.map((prop, key) => {
                                        return (
                                            <PrivateRoute
                                                path={prop.layout + prop.path}
                                                component={prop.component}
                                                key={key}
                                                roles={[Role.Admin]} currentUser={currentUser}
                                            />

                                        );
                                    })}
                                    <PrivateRoute
                                        path="admin/datos-generales"
                                        component={DatosGenerales}
                                        key="datos-generales"
                                        currentUser={currentUser}
                                    />
                                </Switch> */}
                                <ModalActualizarDatosPers
                                    show={this.state.currentUser.ultimoCambio && this.state.currentUser.token && this.state.currentUser.showModalActualizarDP && this.state.showModalCambios}
                                    fechaActualizacion={this.state.currentUser.ultimoCambioDatosPersonales}
                                    tokenUser={this.state.currentUser.token}
                                    onClose={() => this.setState({ showModalCambios: false })}

                                />

                                <ModalTiempoSesion
                                    show={this.state.showModalSession}
                                    tokenUser={authenticationService.currentUserValue.token}
                                    onClose={() => { this.setState({ showModalSession: false }) }}
                                />

                            </div>
                        </div>

                        {/* <div className="contenedor_texto_actualizacion">
                        {currentUser && currentUser.ultimoCambio
                        ? <div className="ultima-actualizacion col-12 pt-2 mr-5" align="right" style={{ color: "#B2B2B2" }}><em> &Uacute;ltima actualizaci&oacute;n: {currentUser.ultimoCambio.toLocaleString('es-EC', { 'year': 'numeric', 'month': '2-digit', 'day': '2-digit'}) }</em></div>
                        : ''}
                    </div> */}

                    </div>
                }
                <Footer fluid />
            </div>
        );
    }
}

export default Dashboard;
